import './QuarantineModal.sass';
import {Button, CircularProgress, DialogContent, Typography} from '@material-ui/core';
import Modal from 'Shared/components/Modal';
import {toFormattedDate} from 'Shared/utilities/DateFormatter';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {acknowledgeQuarantineMessage, fetchQuarantineMessages} from '../../ducks/quarantine';

const QuarantineModal: React.FC = () => {
  const dispatch = useDispatch();
  const {messages, acknowledged, isLoaded, isLoading} = useSelector((state: ReducerState) => state.quarantine);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      dispatch(fetchQuarantineMessages());
    }
  }, [dispatch, isLoaded, isLoading]);

  useEffect(() => {
    setOpen(messages.length > 0 && !acknowledged);
  }, [messages, acknowledged]);

  const handleAcknowledge = () => {
    if (messages.length > 0 && !isLoading) {
      dispatch(acknowledgeQuarantineMessage(messages[0].contentId));
    }
  };

  if (!messages.length || acknowledged) return null;

  const message = messages[0];

  const renderIdentifier = () => {
    if (message.policyNumber) {
      return (
        <Typography component="li">
          <strong>Policy#:</strong> {message.policyNumber}
        </Typography>
      );
    }
    
    if (message.accountNumber) {
      return (
        <Typography component="li">
          <strong>Account#:</strong> {message.accountNumber}
        </Typography>
      );
    }
    
    return null;
  };

  return (
    <Modal title="Document Quarantined" open={open} disableBackdropClick={true} maxWidth="sm" hideCloseButton={true}   className="quarantine-modal__title"    >
      <DialogContent>
        <Typography variant="body1">A virus was detected in your recent document upload:</Typography>
        <ul>
        {renderIdentifier()}
          <Typography component="li">
            <strong>Upload Date:</strong> {toFormattedDate(message?.uploadDate)}
          </Typography>
          <Typography component="li">
            <strong>Filename:</strong> {message?.fileName}
          </Typography>
        </ul>
        <Typography variant="body1">Please upload a virus-free document or submit via fax or mail.</Typography>
        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '16px'}}>
          <Button variant="contained" color="primary" onClick={handleAcknowledge} disabled={isLoading}>
            {isLoading ? <CircularProgress size={20} /> : 'ACCEPT'}
          </Button>
        </div>
      </DialogContent>
    </Modal>
  );
};

export default QuarantineModal;
